<template>
  <div v-bind:class="getPageClasses()">
    <layout-header class="page__header" v-show="showHeader" />
    <div class="page__layout" v-if="user.authenticated">
      <nav class="page__nav" v-bind:class="{ opened: isMenuOpen }" @click="isMenuOpen = !isMenuOpen">
        <nav-bar class="sticky" />
      </nav>
      <section class="page__content">
        <profile-header />
        <div class="dashboard">
          <router-view class="dashboard__topbar" name="topbar" />
          <div class="dashboard__content">
            <router-view class="dashboard__sidebar" name="sidebar" v-show="showSidebar" />
            <router-view class="dashboard__mainview sticky" v-show="showMainView"></router-view>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="page__login-content">
      <router-view></router-view>
    </div>
    <AuditDialogModal />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import stickybits from 'stickybits';
import LayoutHeader from 'common/LayoutHeader';
import ProfileHeader from 'common/ProfileHeader';
import NavBar from 'common/NavBar';
import AuditDialogModal from './components/audit/ShowMore/AuditDialogModal';

export default {
  props: ['hideMainView'],
  name: 'app',
  data() {
    return {
      isMenuOpen: false,
      showHeader: this.getShowHeader(),
      showMainView: this.getShowMainView(),
      showSidebar: this.getShowSidebar(),
      moveAmountToToggleNavBar: 100,
    };
  },
  computed: mapGetters({
    user: 'user/user/user',
    isMobileScreen: 'screen/isMobileScreen',
  }),
  components: {
    AuditDialogModal,
    LayoutHeader,
    ProfileHeader,
    NavBar,
  },
  watch: {
    $route() {
      this.setViewShow();
    },
    isMobileScreen() {
      this.setViewShow();
      this.swipeToggle();
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    getShowHeader() {
      if (this.$route.name === 'parkingSession') {
        return false;
      }
      return true;
    },
    getShowMainView() {
      if (this.$store.getters['screen/isMobileScreen']
        && (this.$route.meta.onMobileScreen
          && typeof this.$route.meta.onMobileScreen.show_mainview === 'boolean')) {
        return this.$route.meta.onMobileScreen.show_mainview;
      }
      return true;
    },
    getShowSidebar() {
      if (this.$store.getters['screen/isMobileScreen']
        && (this.$route.meta.onMobileScreen
          && typeof this.$route.meta.onMobileScreen.show_sidebar === 'boolean')) {
        return this.$route.meta.onMobileScreen.show_sidebar;
      }
      return true;
    },
    setViewShow() {
      this.showSidebar = this.getShowSidebar();
      this.showMainView = this.getShowMainView();
    },
    toggleOnMovement(cordX) {
      if (cordX < (this.firstMousePosX - this.moveAmountToToggleNavBar)
        && this.isMenuOpen) {
        this.toggleMenu();
      } else if (cordX > (this.firstMousePosX + this.moveAmountToToggleNavBar)
        && !this.isMenuOpen) {
        this.toggleMenu();
      }
    },
    swipeToggle() {
      if (this.isMobileScreen) {
        // WITH MOUSE
        window.addEventListener('mousedown', (event) => {
          this.firstMousePosX = event.clientX;
          this.handleMouseDrag = window.addEventListener('mousemove', (e) => {
            this.toggleOnMovement(e.clientX);
          });
          window.addEventListener('mouseup', () => {
            window.removeEventListener('mousemove', this.handleMouseDrag);
          });
        });
        // WITH TOUCH
        window.addEventListener('touchstart', (event) => {
          this.firstMousePosX = event.targetTouches[0].pageX;
          this.handleMouseDrag = window.addEventListener('touchmove', (e) => {
            this.toggleOnMovement(e.targetTouches[0].pageX);
          });
          window.addEventListener('touchend', () => {
            window.removeEventListener('touchmove', this.handleMouseDrag);
          });
        });
      }
    },
    getPageClasses() {
      const themeClass = this.user.landlord_theme;

      return {
        page: true,
        base: true,
        [process.env.PAGE_CLASS]: process.env.PAGE_CLASS,
        [themeClass]: themeClass,
      };
    },
  },
  created() {
    this.$store.dispatch('user/user/checkAuth', JSON.parse(localStorage.getItem('user')));
  },
  mounted() {
    stickybits('.sticky');
  },
  updated() {
    stickybits('.sticky');
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 100vh;
  max-width: 100vw;

  &__layout {
    background-color: var(--brand-background);
    display: flex;
    flex: 1 0 auto;
    position: relative;
  }

  &__nav {
    min-height: 100%;
    width: 100px;
    background-color: var(--grey-one);
    transition: all 225ms ease-in-out;

    @media screen and (max-width: 520px) {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      height: 100%;

      &:not(.opened) {
        left: -100px;
      }

    }

  }

  &__content {
    width: calc(100% - 100px);
    width: -moz-calc(100% - 100px);
    width: -webkit-calc(100% - 100px);
    background-color: var(--grey-four);
    display: flex;
    flex-direction: column;
    align-items: stretch;

    @media screen and (max-width: 775px) {
      /*padding: 20px 15px 0;*/
    }

    @media screen and (max-width: 520px) {
      width: 100%;
    }

    @media screen and (max-width: 450px) {
      /*padding: 20px 0 0;*/
    }
  }

  &__login-content {
    position: relative;
    min-height: calc(100vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue